import type { ReactElement, ReactNode } from 'react';
import { Box } from '@ksyos/design-system';
import { styled } from 'styled-components';
import type { Button, IconButton, Link } from '@frontend/components/elements/common';

interface IProcessStartWizardRowLayoutProps {
    action?: ReactElement<typeof Button | typeof Link | typeof IconButton>;
    children: ReactNode;
}

export function ProcessStartWizardRowLayout(props: IProcessStartWizardRowLayoutProps) {
    return (
        <StyledProcessStartWizardRowLayout className="automation-formWizardRow">
            <Box flex="1 1 100%">{props.children}</Box>
            {props.action}
        </StyledProcessStartWizardRowLayout>
    );
}

const StyledProcessStartWizardRowLayout = styled.div`
    padding: 22px 24px;
    display: flex;

    & + & {
        border-top: 1px solid ${(props) => props.theme.colors.neutral100};
        margin-top: -1px;
    }
`;
